// Modules
import React from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

// Components
import TriageList from 'modules/triage/triage-list';
import TriageRefreshIndicator from 'modules/triage/refresh-indicator';
import SVG from 'components/widgets/icons/svg';
import ReactSelect from "react-select";
import { useTriageItems } from "modules/triage/store/actions";

// Constants
import { rightPaneWidth, isMobile } from 'constants';

import _ from "lodash";

const RightPane = (props) => {
  const { closeRightPane, user, layout: { position, collapsed }, teams } = props;
  const { team, setTeam } = useTriageItems({ user });

  const style = {};
  const paneOpen = position === 0;
  const nullTeamSelect = { label: "All Teams", value: null };


  if (position === rightPaneWidth) style.boxShadow = 'none';
  if (isMobile) style.transform = `translate3d(${position}px, 0, 0)`;

  return (
    <div style={style} id="right-pane" className={classNames({ open: paneOpen, collapsed })}>

      <div style={{ position: "relative", zIndex: "100" }}>
        <ReactSelect
          options={_.map(teams, (t) => ({
            value: t.id,
            label: t.name
          })).concat([nullTeamSelect])}
          defaultValue={nullTeamSelect}
          value={team ? { value: team.id, label: team.name } : { value: null, label: "All Teams" }}
          onChange={(val) => {
            if (val) {
              setTeam(
                teams.filter((t) => t.id === val.value).length
                  ? teams.filter((t) => t.id === val.value)[0]
                  : null
              );
            } else {
              setTeam(null);
            }
          }}
          style={{ borderRadius: "0", border: "0" }}
        />
      </div>

      {/*
        The refresh indicator covers this header while an update is held, rather
        than sitting in the queue. It appears precisely when someone is
        mid-interaction, so anything over the list would hide the rows they are
        working in — and anything in flow would shift those rows, the exact thing
        the refresh gate exists to prevent. The header is the one piece of chrome
        it can take over harmlessly, and being a child of it means no hardcoded
        offset and nothing to scroll away or get clipped. It finds the gate by
        selector, so nothing is passed to it.
      */}
      <div className="tab-header">
        <SVG src="svg/triage.svg" className="triage" />
        <span className="tab-header-title">Triage</span>
        { isMobile && <SVG src="svg/close.svg" onClick={closeRightPane} /> }

        <TriageRefreshIndicator />
      </div>


      <div className="tab-contents">
        <TriageList />
      </div>
    </div>
  );
};

RightPane.propTypes = {
  triageItems: PropTypes.array,
  teams: PropTypes.array,
  layout: PropTypes.object,
  user: PropTypes.object,
  closeRightPane: PropTypes.func.isRequired,
  openRightPane: PropTypes.func.isRequired,
  closingRightPane: PropTypes.func.isRequired
};


// Internal methods
function mapStateToProps(state) {
  return {
    triageItems: state.triage.items,
    teams: state.pageData.teams,
    layout: state.layout.rightPane,
    user: state.auth.currentUser
  };
}


// Exports
export default connect(mapStateToProps)(RightPane);
